import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { BaseInput } from '../../../shared/ui';

type GoalIntroFieldProps = {
  goalText: string;
  onGoalTextChange: (value: string) => void;
};

const GOAL_INTRO_FIELD_ID = 'registration-goals-goal-text';
const GOAL_INTRO_MAX_LENGTH = 200;

const Field = styled.div.attrs({
  'data-ui': 'registration-goals-goal-intro-field',
})`
  width: ${({ theme }) => theme.scale.px(353)};
  display: grid;
  gap: ${({ theme }) => theme.scale.px(6)};
`;

const Label = styled.label`
  font-size: ${({ theme }) => theme.scale.px(12)};
  font-weight: 600;
  line-height: 1.25;
`;

const GoalInput = styled(BaseInput)`
  width: 100%;
  min-height: ${({ theme }) => theme.scale.px(56)};
  box-sizing: border-box;
  padding: ${({ theme }) => theme.scale.px(18)}
    ${({ theme }) => theme.scale.px(13)};
  border-radius: ${({ theme }) => theme.scale.px(10)};
  background: ${({ theme }) => theme.colors.surface.subtle};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.scale.px(12)};
  font-weight: 400;
  line-height: 1.25;

  &::placeholder {
    color: ${({ theme }) => theme.colors.border.emphasis};
  }
`;

export function GoalIntroField({
  goalText,
  onGoalTextChange,
}: GoalIntroFieldProps) {
  const { t } = useTranslation();

  return (
    <Field>
      <Label htmlFor={GOAL_INTRO_FIELD_ID}>
        {t('registrationGoals.goalLabel')}
      </Label>
      <GoalInput
        id={GOAL_INTRO_FIELD_ID}
        aria-label={t('registrationGoals.goalAria')}
        maxLength={GOAL_INTRO_MAX_LENGTH}
        placeholder={t('registrationGoals.goalPlaceholder')}
        value={goalText}
        onChange={event => onGoalTextChange(event.target.value)}
      />
    </Field>
  );
}
